import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Search } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const PAGES = ["/", "/about", "/blog", "/inspiration", "/open-days"];

/** Mobile-only floating call to action, shown to signed-out visitors once they scroll past the top of marketing pages. Sits above the bottom menu bar. */
export function StickyMobileCTA() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);
  const eligible = !user && PAGES.some((p) => (p === "/" ? pathname === "/" : pathname.startsWith(p)));

  useEffect(() => {
    if (!eligible) return;
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [eligible, pathname]);

  if (!eligible) return null;

  return (
    <div
      className={`fixed inset-x-0 z-40 flex justify-center px-4 transition-all duration-300 md:hidden ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      }`}
      style={{ bottom: "calc(4.75rem + env(safe-area-inset-bottom, 0px))" }}
    >
      <Link
        to="/directory"
        className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-medium text-primary-foreground shadow-lg"
      >
        <Search className="h-4 w-4" /> Find venues & suppliers
      </Link>
    </div>
  );
}
